// extracted by mini-css-extract-plugin
export var copyIcon = "_yg-2";
export var discountCard = "_yg-0";
export var discountCode = "_yg-3";
export var discountContent = "_yg-1";
export var loadingCard = "_yg-4";